export default __webpack_public_path__ + "static/media/coffe3.41e7f0d3.png";